import "./icon.custom.objectCadastre.css"
import type { ComponentProps } from "react"
import cn from "@/v2-ui/utils/utils.cn"

export type IconCustomObjectCadastreProps = ComponentProps<"svg">
function IconCustomObjectCadastre(props: IconCustomObjectCadastreProps) {
  const { className, viewBox = "0 0 16 16", fill = "none", ...svgProps } = props

  return (
    <svg
      className={cn("objectCadastre__svg", className)}
      viewBox={viewBox}
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
      {...svgProps}
    >
      <path
        className="objectCadastre__svg_main"
        d="M1 6.93677C1 6.4609 1.20342 6.00772 1.55898 5.69145L5.72565 1.98527C6.35725 1.42347 7.30941 1.42347 7.94102 1.98527L12.1077 5.69145C12.4633 6.00772 12.6667 6.46089 12.6667 6.93676V11C12.6667 11.9205 11.9205 12.6667 11 12.6667H2.66667C1.74619 12.6667 1 11.9205 1 11V6.93677Z"
      />
      <path
        className="objectCadastre__svg_second"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.33337 14V14.3333C4.33337 15.2538 5.07957 16 6.00004 16H14.3334C15.2538 16 16 15.2538 16 14.3333V10.2701C16 9.79419 15.7966 9.34102 15.4411 9.02475L14 7.74295V12.3333C14 13.2538 13.2538 14 12.3333 14H4.33337Z"
      />
    </svg>
  )
}

export default IconCustomObjectCadastre
